import { Space, Typography } from "antd";

import { FC, useContext } from "react";
import { useTheme } from "../../../../Styles/ThemeHook";
import { BedIcon } from "shared-components/Components/CustomIcons/BedIcon/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { firstLetterToUppercase } from "src/utils/Functions";

interface BedroomsTagProps {
	bedrooms: number;
	propertyType?: number | string;
	icon?: boolean;
	prefix?: boolean;
	isEspecial?: Boolean;
}

export const BedroomsTag: FC<BedroomsTagProps> = ({
	bedrooms,
	propertyType,
	icon = false,
	prefix = false,
	isEspecial,
}) => {
	const { theme } = useTheme();
	const { translations, country_code } = useContext(ConfigStateContext);
	const isStudioType = Number(propertyType) === 14;
	const bedroomsLabel = firstLetterToUppercase(translations.hab);
	const hideZeroBedrooms = country_code === "CO" && bedrooms === 0 && !isStudioType;

	if (!isEspecial && hideZeroBedrooms) return null;

	return (
		<div className="typology-item-container">
			{isEspecial ? (
				<>
					{icon ? <BedIcon /> : null}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							{firstLetterToUppercase(translations.hab)}s.
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{prefix ? `${bedrooms > 0 ? bedrooms : "Mono"}`+'+' : bedrooms}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <BedIcon />}
					<Typography.Text ellipsis>
						{`${bedrooms === 0
							? country_code !== "CO"
								? "Mono"
								: isStudioType
									? `1 ${bedroomsLabel}`
									: ""
							: `${bedrooms}${prefix ? "+" : ""} ${bedroomsLabel}${bedrooms === 1 ? "" : "s"}.`}`}
						{/* {`${prefix ? "+" : ""}${bedrooms} ${firstLetterToUppercase(translations.hab)}s.`} */}
					</Typography.Text>
				</>
			)}
		</div>
	);
};
